/* Osang — 스크롤 리빌(.r/.clip) + 패럴랙스([data-px]).
   핸드오프: 리빌은 IntersectionObserver, 패럴랙스는 rAF throttle, reduced-motion 폴백 필수.
   Shopify 테마 에디터의 section 재로드(shopify:section:load)에도 재스캔. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('.r, .clip').forEach(function (el) { el.classList.add('show'); });
  }

  var io = null;
  function initReveal(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('.r, .clip');
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('show'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('show'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    }
    nodes.forEach(function (el) { if (!el.classList.contains('show')) io.observe(el); });
  }

  var pxEls = [];
  function collectPx(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-px]').forEach(function (el) {
      if (parseFloat(el.dataset.px) > 0 && pxEls.indexOf(el) === -1) pxEls.push(el);
    });
  }
  var pxTick = false;
  function runPx() {
    var vh = window.innerHeight;
    pxEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) return;
      var off = (r.top + r.height / 2 - vh / 2) / vh;
      var amt = parseFloat(el.dataset.px) || 16;
      el.style.transform = 'translate3d(0,' + (off * -amt).toFixed(1) + 'px,0)';
    });
  }
  function onScroll() {
    if (pxTick) return;
    pxTick = true;
    requestAnimationFrame(function () { runPx(); pxTick = false; });
  }

  function init(scope) {
    initReveal(scope);
    if (!reduce) { collectPx(scope); runPx(); }
  }

  function boot() {
    init(document);
    if (!reduce) window.addEventListener('scroll', onScroll, { passive: true });
    // 폰트/이미지 로드 후 위치가 밀릴 수 있어 재확인
    window.addEventListener('load', function () { runPx(); });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // 테마 에디터에서 섹션을 추가/재로드할 때 새 노드 재스캔
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
